import { render } from "./Nerf.vue?vue&type=template&id=401bd504&scoped=true"
import script from "./Nerf.vue?vue&type=script&lang=js"
export * from "./Nerf.vue?vue&type=script&lang=js"

import "./Nerf.vue?vue&type=style&index=0&id=401bd504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401bd504"]])

export default __exports__